var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSibling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 7,
    viewBox: "0 0 34 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10742 3.37891L5.44727 4.55664V6.19727L0.402344 4.05859V2.67578L5.44727 0.537109V2.17773L2.10742 3.37891ZM8.21289 3.37891L11.5527 4.55664V6.19727L6.50781 4.05859V2.67578L11.5527 0.537109V2.17773L8.21289 3.37891ZM16.2402 4.0293H12.9414V2.66406H16.2402V4.0293ZM20.8926 4.0293H17.5938V2.66406H20.8926V4.0293ZM25.709 3.36133L22.3047 2.17188V0.542969L27.4082 2.68164V4.05859L22.3047 6.20312V4.56836L25.709 3.36133ZM31.9082 3.36133L28.5039 2.17188V0.542969L33.6074 2.68164V4.05859L28.5039 6.20312V4.56836L31.9082 3.36133Z",
    fill: "#385CDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSibling);
export default __webpack_public_path__ + "static/media/sibling.eeb57d4bd6e0cc15691a60553cf6a643.svg";
export { ForwardRef as ReactComponent };